import gql from "graphql-tag";
import graphqlClient from "../../../../apollo";

class UserProvider {
  auth(username, password) {
    return graphqlClient.mutate({
      mutation: gql`

        mutation ($username: String!, $password: String!) {
          auth(input: { username: $username, password: $password }) {
            token
            user {
              id
              username
              email
              firstName
              lastName
            }
          }
        }
      `,
      variables: {
        username,
        password,
      },
    });
  }

  getMe() {
    return graphqlClient.query({
      query: gql`
        query {
          me {
            id
            username
            email
            firstName
            lastName
          }
        }
      `,
    });
  }


  getDateUpdate() {
    return graphqlClient.query({
      query: gql`
        query {
          lastUpdate {
            date
          }
        }
      `,
    });
  }
}

export default new UserProvider();
